export const roleSorting = [
    'all',
    'itse',
    'esihenkilö',
    'kollegat',
    'tiimin jäsenet',
  ]